import valid from './valid/valid'
import fn from './fn/index'
import baseStorage from './storage/baseStorage'
export  {valid, fn, baseStorage}
